<template>
  <div class="ts-border ts-p-3 ts-rounded">
    <div class="row">
      <div class="col-md-6 ts-space-y-3">
        <div class="row">
          <label class="form-col-label control-label col-md-3">
            {{ $t('purchaseRequest.prDate') }} :
          </label>
          <div class="col-md-7">
            <label class="form-col-label control-label ts-text-blue-700">
              <b>{{ edit_data.pr_date ? edit_data.pr_date : 'N/A' }}</b>
            </label>
          </div>
        </div>
        <div class="row">
          <label class="form-col-label control-label col-md-3">
            {{ $t('purchaseRequest.requiredDate') }} :
          </label>
          <div class="col-md-7">
            <label class="form-col-label control-label ts-text-blue-700">
              <b>{{ edit_data.required_date ? edit_data.required_date : 'N/A' }}</b>
            </label>
          </div>
        </div>
        <div class="row">
          <label class="form-col-label control-label col-md-3">
            {{ $t('purchaseRequest.customer') }} :
          </label>
          <div class="col-md-7">
            <label class="form-col-label control-label ts-text-blue-700">
              <b>{{ edit_data.customer ? edit_data.customer.customer_name : 'N/A' }}</b>
            </label>
          </div>
        </div>
      </div>
      <div class="col-md-6 ts-space-y-3">
        <div class="row">
          <label class="form-col-label control-label col-md-3 ">
            {{ $t('purchaseRequest.prBy') }} :
          </label>
          <div class="col-md-7">
            <label class="form-col-label control-label ts-text-blue-700">
              <b>{{ edit_data.pr_by_emp ? edit_data.pr_by_emp.employee_name_en : 'N/A' }}</b>
            </label>
          </div>
        </div>
        <div class="row">
          <label class="form-col-label control-label col-md-3">
            {{ $t('purchaseRequest.project') }} :
          </label>
          <div class="col-md-7">
            <label class="form-col-label control-label ts-text-blue-700">
              <b>{{ edit_data.project ? edit_data.project.project_name : 'N/A' }}</b>
            </label>
          </div>
        </div>
        <div class="row">
          <label class="form-col-label control-label col-md-3">
            {{ $t('purchaseRequest.remarks') }} :
          </label>
          <div class="col-md-7">
            <label class="form-col-label control-label ts-text-blue-700" style="text-align: left !important;">
              <b>{{ edit_data.remarks ? edit_data.remarks : 'N/A' }}</b>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'purchaseInfo',
  props: ['value', 'validate'],
  data() {
    return {
      model: {},
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    ...mapState('purchaseRequest/purchaseRequest', ['edit_data']),
  },
  methods: {},
}
</script>